import { ChangeDetectionStrategy, Component, inject, input, TemplateRef } from '@angular/core';
import { OrderCappingToastService } from '../../services/order-capping-toast.service';
import { I18nModule } from '@spartacus/core';
import { ICON_TYPE, IconModule } from '@spartacus/storefront';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'sanofi-order-capping-toasts',
  standalone: true,
  templateUrl: './order-capping-toasts.component.html',
  imports: [
    I18nModule,
    IconModule,
    RouterLink
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderCappingToastsComponent {
  private readonly toastService = inject(OrderCappingToastService);
  allocatedQty = input.required<string>();
  limitReached = input.required<boolean>();
  productAnchorId = input.required<string | null>();
  protected readonly ICON_TYPE = ICON_TYPE;

  hideToast(template: TemplateRef<any>): void {
    this.toastService.remove({ template });
  }
}
